import { useEffect, useContext } from 'react';
import { getCampaignList } from '../services/index.service';
import { storeContext } from '../../provider/Provider';
import { digitalPRActions } from '../../../store/digital-pr-reducer';

const useLoadActiveFullView = () => {
   const { state, dispatch } = useContext(storeContext);
   // const COMPLETE = 'complete';
   const monthDescending = '-month';
   
   useEffect(() => {
      const fetchCampaignList = async () => {
         dispatch({
            type: digitalPRActions.SET_LOADING,
            payload: { 
                  campaignsLoading: true,
               },
         });
         try {
             const res = await getCampaignList({
               with_groups: true,
               page: state.digitalPR.campaignFilters.page + 1,
               page_size: state.digitalPR.campaignFilters.perPage,
               ordering: monthDescending,
               client_domain: state.websiteSwitch.currentWebsite,
               reviewed: true,
               date_range_after: state.digitalPR.campaignFilters.fromDate,
               date_range_before: state.digitalPR.campaignFilters.toDate,
               search: state.digitalPR.campaignFilters.searchTerm,
             });
             if (!res.data) {
                 return;
             }
             
            dispatch({
               type: digitalPRActions.SET_CAMPAIGNS,
               payload: { 
                  campaignList: res.data?.results,
               }
            });
            dispatch({
               type: digitalPRActions.SET_TOTAL_CAMPAIGNS,
               payload: { 
                  totalCampaigns: res.data?.count
               }
            });
         } finally {
            dispatch({
               type: digitalPRActions.SET_LOADING,
               payload: { 
                campaignsLoading: false,
               }
            });
         }
     }
     fetchCampaignList();
   }, [
      state.digitalPR.campaignFilters.page, 
      state.digitalPR.campaignFilters.perPage, 
      state.digitalPR.campaignFilters.fromDate, 
      state.digitalPR.campaignFilters.toDate, 
      state.digitalPR.campaignFilters.searchTerm,
      state.digitalPR.activeOrderBy,
      state.websiteSwitch.currentWebsite,
   ])
}

export default useLoadActiveFullView